import { useEffect } from "react";

export default function Terms() {
  useEffect(() => {
    // The NFP Terms of Use is the Apple Standard EULA per problem statement.
    window.location.replace(
      "https://www.apple.com/legal/internet-services/itunes/dev/stdeula/"
    );
  }, []);

  return (
    <div
      className="min-h-screen bg-[#0a0a0a] text-white flex items-center justify-center px-6 text-center"
      data-testid="page-terms"
    >
      <div>
        <p className="text-[11px] tracking-[0.3em] uppercase text-[#00E5FF]">Redirecting</p>
        <h1 className="nfp-heading text-3xl mt-3">Terms of Use (Apple Standard EULA)</h1>
        <p className="mt-3 text-white/60 max-w-md mx-auto">
          You are being redirected to Apple's Standard EULA. If your browser
          doesn't redirect,{" "}
          <a
            href="https://www.apple.com/legal/internet-services/itunes/dev/stdeula/"
            className="text-[#00E5FF] hover:underline"
          >
            click here
          </a>
          .
        </p>
      </div>
    </div>
  );
}
